import { Link } from "react-router-dom";
import "./SupportCase.css";
import Nav from "../Navbar-footer/Nav";
import Foot from "../Navbar-footer/Foot";


function SupportCase() {
  return (
    <>
    <Nav />
    <div className="support-background">
      <div className="support-glass">
        <h1 className="support-title">Be a Lifesaver Today</h1>
        <p className="support-subtitle">
          Join hands with us to spread hope, compassion, and life through blood donation.
        </p>

        <div className="support-button-group">
          <Link to="/tabs" className="support-link">
            <button className="support-button">📋 View Requests</button>
          </Link>
          <Link to="/membership" className="support-link">
            <button className="support-button">💳 Membership</button>
          </Link>
        </div>

        <div className="support-info">
          <div className="info-card">
            <h3>💖 Why Help Others?</h3>
            <p>
              A single blood donation can save up to 3 lives. Your help means the world to someone in need.
            </p>
          </div>
          <div className="info-card">
            <h3>🌟 Why Join Us?</h3>
            <p>
              Get exclusive member benefits, stay informed, and be part of a purpose-driven community.
            </p>
          </div>
          <div className="info-card">
            <h3>🤝 How You Can Help</h3>
            <p>
              Become a donor, spread awareness, or volunteer your time. Every effort counts.
            </p>
          </div>
        </div>
      </div>
    </div>
    <Foot/>
    </>
    
    
  );
}

export default SupportCase;
